import Vue from 'vue';

    import commentAnalysisApi from '@/hotelcem/apis/comment/commentAnalysis'

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    
const AllChannelList = [
  {
    value: 'meituan',
    label: $t('9a24ae'),
    img: 'meituan.png',
    configValue: 1,
    order: 3,
    CommentListPageConfig: {
      name: $t('9a24ae'),
      totalBiKey: 'mtTotal',
      rawDataBiKey: $t('9a24ae'),
      formSearchValue: 'meituan',
      channel: 1,
      chineseSource: $t('9a24ae'),
    },
    CommentAnalysisConfig: {
      channel: 'mt',
    },
    url: '',
  },
  {
    value: 'ctrip',
    label: $t('e3f92d'),
    img: 'xiecheng.png',
    configValue: 2,
    order: 0,
    CommentListPageConfig: {
      name: $t('e3f92d'),
      totalBiKey: 'xcTotal',
      rawDataBiKey: $t('e3f92d'),
      formSearchValue: 'ctrip',
      channel: 2,
      chineseSource: $t('e3f92d'),
    },
    CommentAnalysisConfig: {
      channel: 'xc',
    },
    url: '',
  },
  {
    value: 'elong',
    label: $t('df1df6'),
    img: 'elong.png',
    configValue: 3,
    order: 1,
    CommentListPageConfig: {
      name: $t('df1df6'),
      totalBiKey: 'ylTotal',
      rawDataBiKey: $t('c315a5'),
      formSearchValue: 'yilong',
      channel: 3,
      chineseSource: $t('df1df6'),
    },
    CommentAnalysisConfig: {
      channel: 'yl',
    },
    url: '',
  },
  {
    value: 'qunar',
    label: $t('13611a'),
    img: 'qunaer.png',
    configValue: 4,
    order: 2,
    CommentListPageConfig: {
      name: $t('13611a'),
      totalBiKey: 'qnrTotal',
      rawDataBiKey: $t('13611a'),
      formSearchValue: 'qunaer',
      channel: 4,
      chineseSource: $t('13611a'),
    },
    CommentAnalysisConfig: {
      channel: 'qnr',
    },
    url: '',
  },
  {
    value: 'fliggy',
    label: $t('cf5ecd'),
    img: 'feizhu.png',
    configValue: 5,
    order: 5,
    CommentListPageConfig: {
      name: $t('cf5ecd'),
      totalBiKey: 'fzTotal',
      rawDataBiKey: $t('cf5ecd'),
      formSearchValue: 'feizhu',
      channel: 5,
      chineseSource: $t('cf5ecd'),
    },
    CommentAnalysisConfig: {
      channel: 'fz',
    },
    url: '',
  },
  {
    value: 'dianping',
    label: $t('a27bcf'),
    img: 'dianping.png',
    configValue: 6,
    order: 4,
    CommentListPageConfig: {
      name: $t('a27bcf'),
      totalBiKey: 'dpTotal',
      rawDataBiKey: $t('872e7e'),
      formSearchValue: 'dianping',
      channel: 6,
      chineseSource: $t('872e7e'),
    },
    CommentAnalysisConfig: {
      channel: 'dp',
    },
    url: '',
  },
  {
    value: 'kaiyuan',
    label: $t('ca6b52'),
    img: 'kaiyuan.png',
    configValue: 7,
    order: 6,
    CommentListPageConfig: {
      name: $t('ca6b52'),
      totalBiKey: 'kyTotal',
      rawDataBiKey: $t('ca6b52'),
      formSearchValue: 'kaiyuan',
      channel: 7,
      chineseSource: $t('ca6b52'),
    },
    CommentAnalysisConfig: {
      channel: 'ky',
    },
    url: '',
  },
  {
    value: 'custom_wanda',
    label: $t('d171f1'),
    img: 'wanda.png',
    configValue: 8,
    order: 8,
    CommentListPageConfig: {
      name: $t('d171f1'),
      totalBiKey: 'custom_wandaTotal',
      rawDataBiKey: $t('d171f1'),
      formSearchValue: 'custom_wanda',
      channel: 8,
      chineseSource: $t('d171f1'),
    },
    CommentAnalysisConfig: {
      channel: 'custom_wanda',
    },
    url: '',
  },
  {
    value: 'booking',
    label: 'Booking.com',
    img: 'booking.png',
    configValue: 9,
    order: 9,
    CommentListPageConfig: {
      name: 'Booking.com',
      totalBiKey: 'bookingTotal',
      rawDataBiKey: 'Booking',
      formSearchValue: 'booking',
      channel: 9,
      chineseSource: 'Booking',
    },
    CommentAnalysisConfig: {
      channel: 'booking',
    },
    url: '',
  },
  {
    value: 'tripadvisor',
    label: $t('ed7caf'),
    img: 'tripadvisor.png',
    configValue: 10,
    order: 10,
    CommentListPageConfig: {
      name: $t('ed7caf'),
      totalBiKey: 'tripadvisorTotal',
      rawDataBiKey: $t('ed7caf'),
      formSearchValue: 'tripadvisor',
      channel: 10,
      chineseSource: $t('ed7caf'),
    },
    CommentAnalysisConfig: {
      channel: 'tripadvisor',
    },
    url: '',
  },
  {
    value: 'expedia',
    label: 'Expedia',
    img: 'expedia.png',
    configValue: 11,
    order: 11,
    CommentListPageConfig: {
      name: 'Expedia',
      totalBiKey: 'expediaTotal',
      rawDataBiKey: 'expedia',
      formSearchValue: 'expedia',
      channel: 11,
      chineseSource: 'expedia',
    },
    CommentAnalysisConfig: {
      channel: 'expedia',
    },
    url: '',
  },
  {
    value: 'hotel_com',
    label: 'Hotels.com',
    img: 'hotel.png',
    configValue: 12,
    order: 12,
    CommentListPageConfig: {
      name: 'Hotels.com',
      totalBiKey: 'hotelComTotal',
      rawDataBiKey: 'Hotel',
      formSearchValue: 'hotel_com',
      channel: 12,
      chineseSource: 'Hotel',
    },
    CommentAnalysisConfig: {
      channel: 'hotel_com',
    },
    url: '',
  },
  {
    value: 'tripadvisor_en',
    label: 'Tripadvisor',
    img: 'TRIPADVISOR_EN.png',
    configValue: 13,
    order: 13,
    CommentListPageConfig: {
      name: 'Tripadvisor',
      totalBiKey: 'tripadvisorEnTotal',
      rawDataBiKey: 'TripadvisorEn',
      formSearchValue: 'tripadvisor_en',
      channel: 13,
      chineseSource: 'TripadvisorEn',
    },
    CommentAnalysisConfig: {
      channel: 'tripadvisor_en',
    },
    url: '',
  },
  {
    value: 'agoda',
    label: 'Agoda',
    img: 'Agoda.png',
    configValue: 14,
    order: 14,
    CommentListPageConfig: {
      name: 'Agoda',
      totalBiKey: 'agodaTotal',
      rawDataBiKey: 'Agoda',
      formSearchValue: 'agoda',
      channel: 14,
      chineseSource: 'Agoda',
    },
    CommentAnalysisConfig: {
      channel: 'agoda',
    },
    url: '',
  },
  {
    value: 'rujia',
    label: $t('b8ee0c'),
    img: 'rujia.png',
    configValue: 15,
    order: 15,
    CommentListPageConfig: {
      name: $t('b8ee0c'),
      totalBiKey: 'rujiaTotal',
      rawDataBiKey: $t('b8ee0c'),
      formSearchValue: 'rujia',
      channel: 15,
      chineseSource: $t('b8ee0c'),
    },
    CommentAnalysisConfig: {
      channel: 'rujia',
    },
    url: '',
  },
  {
    value: 'yaste',
    label: $t('d88d2c'),
    img: 'yasite.png',
    analysisTitle: $t('c2f945'),
    commentTitle: $t('9c34c7'),
    configValue: 16,
    order: 16,
    CommentAnalysisConfig: {
      channel: 'yasite',
    },
    CommentListPageConfig: {
      name: $t('d88d2c'),
      totalBiKey: 'yasiteTotal',
      rawDataBiKey: $t('d88d2c'),
      formSearchValue: 'yasite',
      channel: 16,
      chineseSource: $t('d88d2c'),
    },
    competitor: 'yasite',
  },
  {
    value: 'douyin',
    label: $t('92b56b'),
    img: 'douyin.png',
    analysisTitle: $t('6381f4'),
    commentTitle: $t('f6360a'),
    configValue: 17,
    order: 17,
    CommentAnalysisConfig: {
      channel: 'douyin',
    },
    CommentListPageConfig: {
      name: $t('92b56b'),
      totalBiKey: 'douyinTotal',
      rawDataBiKey: $t('d88d2c'),
      formSearchValue: 'douyin',
      channel: 17,
      chineseSource: $t('92b56b'),
    },
    competitor: 'douyin',
  },
  {
    value: 'jinjiang',
    label: $t('9f826f'),
    img: 'jinjiang.png',
    analysisTitle: $t('74a264'),
    commentTitle: $t('f8059d'),
    configValue: 18,
    order: 18,
    CommentAnalysisConfig: {
      channel: 'jinjiang',
    },
    CommentListPageConfig: {
      name: $t('9f826f'),
      totalBiKey: 'jinjiangTotal',
      rawDataBiKey: $t('9f826f'),
      formSearchValue: $t('9f826f'),
      channel: 18,
      chineseSource: $t('9f826f'),
    },
    competitor: 'jinjiang',
  },
  {
    value: 'yifei',
    label: $t('27e021'),
    img: 'yifei.png',
    analysisTitle: $t('d2bb09'),
    commentTitle: $t('4fe3c6'),
    configValue: 19,
    order: 19,
    CommentAnalysisConfig: {
      channel: 'yifei',
    },
    CommentListPageConfig: {
      name: $t('27e021'),
      totalBiKey: 'yifeiTotal',
      rawDataBiKey: $t('27e021'),
      formSearchValue: $t('27e021'),
      channel: 19,
      chineseSource: $t('27e021'),
    },
    competitor: 'yifei',
  },
  {
    value: 'google',
    label: $t('4aff2b'),
    img: 'google.png',
    analysisTitle: $t('ad8c9c'),
    commentTitle: $t('97ddce'),
    configValue: 20,
    order: 20,
    CommentAnalysisConfig: {
      channel: 'google',
    },
    CommentListPageConfig: {
      name: $t('4aff2b'),
      totalBiKey: 'googleTotal',
      rawDataBiKey: $t('4aff2b'),
      formSearchValue: $t('4aff2b'),
      channel: 20,
      chineseSource: $t('4aff2b'),
    },
    competitor: 'google',
  },
  {
    value: 'delonix',
    label: $t('d4478c'),
    img: 'dalong.png',
    analysisTitle: $t('f76c08'),
    commentTitle: $t('90166e'),
    configValue: 21,
    order: 21,
    CommentAnalysisConfig: {
      channel: 'delonix',
    },
    CommentListPageConfig: {
      name: $t('d4478c'),
      totalBiKey: 'delonixTotal',
      rawDataBiKey: $t('d4478c'),
      formSearchValue: $t('d4478c'),
      channel: 21,
      chineseSource: $t('d4478c'),
    },
    competitor: 'delonix',
  },
  {
    value: 'delonix_zh',
    label: $t('b7c5fe'),
    img: 'dalong.png',
    analysisTitle: $t('23c2a9'),
    commentTitle: $t('b699f3'),
    configValue: 22,
    order: 22,
    CommentAnalysisConfig: {
      channel: 'delonix_zh',
    },
    CommentListPageConfig: {
      name: $t('b7c5fe'),
      totalBiKey: 'delonix_zhTotal',
      rawDataBiKey: $t('b7c5fe'),
      formSearchValue: $t('b7c5fe'),
      channel: 22,
      chineseSource: $t('b7c5fe'),
    },
    competitor: 'delonix_zh',
  },
  {
    value: 'yifen',
    label: $t('44f60c'),
    img: 'yifen.png',
    analysisTitle: $t('53e94c'),
    commentTitle: $t('07aca4'),
    configValue: 23,
    order: 23,
    CommentAnalysisConfig: {
      channel: 'yifen',
    },
    CommentListPageConfig: {
      name: $t('44f60c'),
      totalBiKey: 'yifenTotal',
      rawDataBiKey: $t('44f60c'),
      formSearchValue: $t('44f60c'),
      channel: 23,
      chineseSource: $t('44f60c'),
    },
    competitor: 'yifen',
  },
  {
    value: 'jinling',
    label: $t('9850bb'),
    img: 'jinling.jpeg',
    analysisTitle: $t('4dc638'),
    commentTitle: $t('28a65e'),
    configValue: 24,
    order: 24,
    CommentAnalysisConfig: {
      channel: 'jinling',
    },
    CommentListPageConfig: {
      name: $t('9850bb'),
      totalBiKey: 'jinlingTotal',
      rawDataBiKey: $t('9850bb'),
      formSearchValue: $t('9850bb'),
      channel: 24,
      chineseSource: $t('9850bb'),
    },
    competitor: 'jinling',
  },
  {
    value: 'gaode',
    label: $t('d4e4d2'),
    img: 'gaode.png',
    analysisTitle: $t('e296c3'),
    commentTitle: $t('f734bc'),
    configValue: 25,
    order: 25,
    CommentAnalysisConfig: {
      channel: 'gaode',
    },
    CommentListPageConfig: {
      name: $t('d4e4d2'),
      totalBiKey: 'gaodeTotal',
      rawDataBiKey: $t('d4e4d2'),
      formSearchValue: $t('d4e4d2'),
      channel: 25,
      chineseSource: $t('d4e4d2'),
    },
    competitor: 'gaode',
  },
]

let ChannelConfigMap = {}
let ChannelConfigLabelMap = {}
let ChannelList = []

let requestPromise
const getChannelList = async (hotelId, payload) => {
  const res = await commentAnalysisApi.paramsQuery({ hotelId, ...payload })

  // if (ChannelList.length > 0) {
  //   return ChannelList
  // }
  ChannelList = []

  if (res.code === 200) {
    if (!ChannelConfigMap[hotelId]) {
      ChannelConfigMap[hotelId] = {}
    }
    if (!ChannelConfigLabelMap[hotelId]) {
      ChannelConfigLabelMap[hotelId] = {}
    }
    for (const channel of AllChannelList) {
      if (res.data[channel.configValue]) {
        ChannelList.push({
          value: channel.value,
          label: channel.label,
          configValue: channel.configValue,
          formSearchValue: channel.CommentListPageConfig.formSearchValue,
          totalBiKey: channel.CommentListPageConfig.totalBiKey,
        })
        ChannelConfigMap[hotelId][channel.value] = channel.label
        ChannelConfigLabelMap[hotelId][channel.label] = channel.value
      }
    }
  }

  return ChannelList
}

const getChannelList2 = async hotelId => {
  ChannelList = []
  const res = await commentAnalysisApi.paramsQuery({
    hotelId: hotelId || window.completeHotelId || '',
  })

  // if (ChannelList.length > 0) {
  //   return ChannelList
  // }
  if (res.code === 200) {
    if (!ChannelConfigMap[hotelId]) {
      ChannelConfigMap[hotelId] = {}
    }
    if (!ChannelConfigLabelMap[hotelId]) {
      ChannelConfigLabelMap[hotelId] = {}
    }
    for (const channel of AllChannelList) {
      // if (res.data[channel.configValue]) {
      ChannelList.push({
        value: channel.value,
        label: channel.label,
        configValue: channel.configValue,
        formSearchValue: channel.CommentListPageConfig.formSearchValue,
        totalBiKey: channel.CommentListPageConfig.totalBiKey,
      })
      ChannelConfigMap[hotelId][channel.value] = channel.label
      ChannelConfigLabelMap[hotelId][channel.label] = channel.value
      // }
    }
  }

  return ChannelList
}
const getChannelConfigMap = async hotelId => {
  if (ChannelList.length === 0 || !ChannelConfigMap[hotelId]) {
    await getChannelList(hotelId)
  }
  return ChannelConfigMap[hotelId]
}
const getChannelConfigLabelMap = async hotelId => {
  if (ChannelList.length === 0 || !ChannelConfigLabelMap[hotelId]) {
    await getChannelList2(hotelId)
  }

  return ChannelConfigLabelMap[hotelId]
}

const getAllChannelConfigMap = () => {
  //
  let cp = {}
  for (const channel of AllChannelList) {
    cp[channel.value] = channel.label
  }
  return cp
}

const getAllChannelConfigLabelMap = () => {
  let cp = {}
  for (const channel of AllChannelList) {
    cp[channel.label] = channel.value
  }
  return cp
}

export async function getChannelValueListByName(name) {
  if (ChannelList.length === 0) {
    await getChannelList(hotelId)
  }
  return ChannelList.reduce((res, item) => {
    if (item.label.indexOf(name) > -1) {
      res.push(item.value)
    }
    return res
  }, [])
}

// 清除 requestPromise
export function clearRequestPromise() {
  requestPromise = undefined
  ChannelConfigMap = {}
  ChannelConfigLabelMap = {}
  ChannelList = []
}

export default {
  getChannelList,
  getChannelConfigMap,
  getChannelConfigLabelMap,
  allChannelList: AllChannelList,
  clearRequestPromise,
  getAllChannelConfigMap,
  getAllChannelConfigLabelMap,
}
